import * as React from 'react';
import { SVGProps } from '../../types';

export const IconResultsGridPencilSvg = ({ title, titleId, ...props }: SVGProps) => (
  <svg
    width={18}
    height={18}
    viewBox="0 0 18 18"
    focusable="false"
    fill="none"
    stroke="currentColor"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      d="M9.04062 12.0122L9.00308 12.0497C8.8553 12.1975 8.67827 12.3128 8.48334 12.3881L4.97294 13.7453C4.77028 13.8237 4.57103 13.6241 4.64978 13.4216L6.01299 9.91616C6.08838 9.72231 6.20326 9.54625 6.35034 9.39917L6.38897 9.36054M9.04062 12.0122L15.051 6.00178C15.2463 5.80652 15.2463 5.48994 15.051 5.29468L13.1065 3.35014C12.9112 3.15488 12.5946 3.15488 12.3994 3.35014L6.38897 9.36054M9.04062 12.0122L8.80171 11.0534C8.62245 10.3339 8.05989 9.7727 7.34002 9.59513L6.38897 9.36054"
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
